import Icon from "components/atoms/icon/Icon";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconType } from "../iconTypes";


export const leaveRequestsHeaders = [
    {
        id: 1,
        Header: "Start Date",
        accessor: (row: any) => new Date(row?.start_date),
        Cell: ({ row }: any) => {
            return (
                <div>
                    {new Date(row.original.start_date).toLocaleDateString('de')}
                </div>
            );
        },
        isChecked: true
    },
    {
        id: 2,
        Header: "End Date",
        accessor: (row: any) => new Date(row?.end_date),
        Cell: ({ row }: any) => {
            return (
                <div>
                    {row.original.end_date ? new Date(row.original.end_date).toLocaleDateString('de') : '-'}
                </div>
            );
        },
        isChecked: true
    },
    {
        id: 3,
        Header: "Start Time",
        accessor: "start_time",
        Cell: ({ row }: any) => {
            return (
                <div>
                    {row.original.start_time ? row.original.start_time : '-'}
                </div>
            );
        },
        isChecked: true
    },
    {
        id: 4,
        Header: "End Time",
        accessor: "end_time",
        Cell: ({ row }: any) => {
            return (
                <div>
                    {row.original.end_time ? row.original.end_time : '-'}
                </div>
            );
        },
        isChecked: true
    },
    {
        id: 5,
        Header: "Type",
        accessor: "absence_type",
        isChecked: true
    },
    {
        id: 6,
        Header: "Comment",
        accessor: "comment",
        Cell: ({ row }: any) => {
            return (
                <div>
                    {row.original.comment ? row.original.comment : '-'}
                </div>
            );
        },
        isChecked: true
    },
    {
        id: 7,
        Header: "Status",
        accessor: "status",
        Cell: ({ row }: any) => {
            return (
                <Status value={row.original.status} />
            );
        },
        isChecked: true
    },
    {
        id: 8,
        Header: "Files",
        accessor: "file",
        Cell: ({ row }: any) => {
            return (
                <Files value={row.original.file} />
            );
        },
        isChecked: true
    },
];

const Status = ({ value }: any) => {
    const [Color, setColor] = useState<string>("");
    const { t } = useTranslation();


    useEffect(() => {
        switch (value) {
            case 'pending':
                setColor("#EFBE12");
                break;

            case 'approved':
                setColor("#2DE28B");
                break;
            case 'rejected':
                setColor("#CC7272");
                break;
        }

    }, [value, t]);

    const CapitalizedValue = useMemo(() => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }, [value])

    return (
        <span
            className={`text-[12px] bg-opacity-10 font-inter-light px-[8px] py-[3px] rounded-[4px] whitespace-nowrap`}
            style={{ background: Color + "1A", color: Color }}
        >
            {t(CapitalizedValue)}
        </span>
    );
};

const Files = ({ value }: any) => {
    const { t } = useTranslation();
    const fileIcon = useMemo(() => {

        if(value === null || value === undefined) {
            return IconType.FILE_JPG_ICON
        }

        const filetype = value.split('.')[1]

        if (filetype === 'pdf') {
            return IconType.FILE_PDF_ICON
        }
        if (filetype === 'csv' ||
            filetype === 'xlsx' ||
            filetype === 'xls') {
            return IconType.UPLOADED_CSV_ICON
        }

        if (filetype === 'doc' || filetype === 'docx') {
            return IconType.FILE_WORD_ICON
        }

        return IconType.FILE_JPG_ICON



    }, [value])

    if (!value) {
        return (
            <div className="text-primaryTextColor font-inter-regular text-sm">
                {t("No files")}
            </div>
        )
    }

    return (
<a className="flex items-center gap-2" href={`${process.env.REACT_APP_API_URL}hr/absence/show-file/` + value} target="_blank" rel="noopener noreferrer">
            <Icon iconType={fileIcon} className="w-7" />
            <span className="text-sm text-primaryTextColor font-inter-regular">{value.split('_')[0]}</span>
        </a>
    );
};

